
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-feed",
      function () {
        return require("private-next-pages/news-feed.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-feed"])
      });
    }
  